"use strict";
var CoverageCartCoverageViewModel = (function () {
    function CoverageCartCoverageViewModel() {
    }
    CoverageCartCoverageViewModel.ConvertEditCoveragesIntoCoverageCartCoverages = function (coverages) {
        var convertedModelList = new Array();
        for (var i = 0; i <= coverages.length - 1; i++) {
            if (coverages[i].isSelected) {
                convertedModelList.push(CoverageCartCoverageViewModel.ConvertCoverageIntoCoverageCartCoverage(coverages[i]));
            }
        }
        return convertedModelList;
    };
    CoverageCartCoverageViewModel.ConvertCoverageIntoCoverageCartCoverage = function (coverage) {
        var convertedCoverage = new CoverageCartCoverageViewModel();
        convertedCoverage.name = coverage.name;
        convertedCoverage.premium = coverage.premium;
        convertedCoverage.shortName = coverage.shortName;
        return convertedCoverage;
    };
    return CoverageCartCoverageViewModel;
}());
exports.CoverageCartCoverageViewModel = CoverageCartCoverageViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverage-cart/coverage-cart-coverage-view.model.js